import React, {ReactComponentElement, useEffect} from "react"
import {ActionAnswer, CommandData} from "../../utils/RequestsHelper"
import {AxiosPromise} from "axios"
import LongActionStatus from "../../store/entities/LongActionStatus"
import {observer} from "mobx-react-lite"
import classNames from "classnames"
import CommandField from "./CommandField";
import entityCompareController from "../../pages/offerAttributes/EntityCompareController"

export const LongActionControls = observer(({command, start, hideInput, buttonText, onEnd, afterButton, action, saveAction}: {
    command?: CommandData | undefined
    start: () => AxiosPromise<ActionAnswer<{ processId: number, text: string }>>
    buttonText?: () => ReactComponentElement<any>
    afterButton?: () => ReactComponentElement<any>
    hideInput?: boolean
    onEnd?: () => void
    action: string
    saveAction?: () => void
}) => {
    const [longActionStatus, setLongActionStatus] = React.useState<LongActionStatus>()

    useEffect(() => {
        setLongActionStatus(new LongActionStatus({
            start,
            success: onEnd,
            last_ended_date: command?.last_start_time,
            action
        }))
    }, [command, start, onEnd])

    if (!buttonText) {
        buttonText = () => <>Запустить</>
    }
    return <>
        {(command && longActionStatus) ? <>
            <div>
                {!hideInput && <CommandField command={command.command}/>}
                <button
                    className={classNames({disabled: longActionStatus.is_running}, "button")}
                    onClick={() => longActionStatus.start()}> {buttonText()} </button>
                {saveAction && <button className={'button green ozon_save'} onClick={saveAction}>Сохранить</button>}
                {afterButton && afterButton()}
            </div>
            {longActionStatus.last_ended_date && <div className={"hint custom-mt-4"}>
                Дата последнего запуска: {longActionStatus.last_ended_date}
            </div>}
        </> : <div>
            Loading...
        </div>}
        {longActionStatus &&  (longActionStatus.is_running ? <div>
            <div className="spinner" style={{margin:'10px 7px -2px 3px'}}></div>{longActionStatus.text}
        </div> :<div>
            {longActionStatus.text}
        </div>)}
    </>
})